import React from 'react'

import { FilterBox } from '../../../../ui'

export const AssociatesIP3Filters = () => {
  return <FilterBox />
}
